
var Array = require("./shim-array");
var Object = require("./shim-object");
var Function = require("./shim-function");
var RegExp = require("./shim-regexp");




//////////////////
// WEBPACK FOOTER
// ./~/collections/shim.js
// module id = 47
// module chunks = 57